import { Component, effect, inject, input } from '@angular/core';

import { EChartsOption } from 'echarts';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';

import { VisualBaseComponent } from '../visual-base.component';
import { QuarterlyGroup } from '../../services/metric.service';
import { StateService } from '../../services/state.service';
import { Group } from '../../services/group.service';

@Component({
  selector: 'app-percentile-quarterly',
  standalone: true,
  imports: [NgxEchartsDirective],
  templateUrl: './percentile-quarterly.component.html',
  styleUrl: './percentile-quarterly.component.scss',
  providers: [provideEcharts()]
})
export class PercentileQuarterlyComponent extends VisualBaseComponent {
  metric = input<QuarterlyGroup | undefined>();

  readonly institution = inject(StateService).institution;
  readonly peer = inject(StateService).peer;
  readonly filteredGroup = inject(StateService).filteredGroup;
  readonly date = inject(StateService).date;

  override initOptions = { height: 150 }
  override baseOptions: EChartsOption = {
    grid: {
      left: 10,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true
    },
    legend: {
      show: true
    },
    xAxis: {
      type: 'category',
      show: true,
      axisLabel: {
        color: '#243b5b'
      },
      data: []
    },
    axisLabel: {
      color: '#002f8e'
    },
    series: [
      {
        type: 'line',
        symbol: 'none',
        symbolSize: 0,
        data: []
      },
      {
        type: 'line',
        symbol: 'none',
        symbolSize: 0,
        data: []
      }
    ]
  };
  override tooltipOptions: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      valueFormatter: value => value != null ? this.getYAxisDisplay(Number(value)) : '--'
    },
    yAxis: {
      //min: 0,
      //max: 100,
      type: 'value',
      show: true,
      axisLabel: {
        color: '#243b5b',
        formatter: function (value: number) {
          const decimals = (!Number.isInteger(value * 100)) ? 1 : 0;
          return (value * 100).toFixed(decimals) + '%';
        }
      },
      splitLine: {
        lineStyle: {
          color: '#ccc'
        }
      }
    }
  };
  override loadingColor = '#ebebeb';

  constructor() {
    super();

    effect(() => {
      const group = this.peer()?.group;
      const date = this.date();
      const metric = this.metric();
      const filteredGroup = this.filteredGroup();
      if (group && date && metric && filteredGroup) {
        this.updateVisual(group, date, metric, filteredGroup.filter(i => i.isSelected).map(i => i.iid));
      }
    });
  }

  public updateVisual(group: Group, date: Date, metric: QuarterlyGroup, iids: number[]) {
    this.metricService.getMetricPercentileData(this.institution().iid, metric.metricId, group.groupId, group.groupType != 30 ? iids : [])?.subscribe(data => {
      const dateRange = { startDate: new Date(new Date(date).setFullYear(new Date(date).getFullYear() - 5)), endDate: date };
      const dataSeries = this.visualService.getMetricSeriesPeer('PCT2', data, dateRange);

      if (dataSeries.institutionSeries.filter(v => v != null).length == 0) {
        this.echartsInstance?.clear();
        this.chartOptions = this.noDataOptions;
      }
      else {
        this.updateOptions = {
          xAxis: {
            data: dataSeries.dateSeries,
          },
          series: [
            {
              name: this.institution()?.name,
              data: dataSeries.institutionSeries,
              color: this.colors[0],
              symbol: 'line',
              symbolSize: 0,
            }
          ]
        };
      }
      this.echartsInstance?.hideLoading();
    });
  }

  protected getYAxisDisplay(value: number): string {
    return (value * 100).toFixed(0) + '%';
  }
}
